export default {
  setPayPwd: '/wdsx-shop/user/savePayPwd',
  updatePayPwd: '/wdsx-shop/user/updatePayPwd',
  updatePhone: '/wdsx-shop/user/updateMobilePhone'
};